import type { TaskTemplate } from "../domain/entities.ts";
import type { PublicConfig, Root, User } from "../domain/app-types.ts";
import type { SyncState } from "../infrastructure/sync/automerge.ts";
import type { SpaceTemplate } from "../features/navigation/space-template-controller.ts";

export interface SessionStateInitial {
  activeRootId: string | null;
  activeCollection?: { id: string; rootId: string } | null;
  syncState: SyncState;
  personalTemplates: TaskTemplate[];
  spaceTemplates: SpaceTemplate[];
  mobileActions: string[];
}

export class SessionState {
  user: User | null = null;
  roots: Root[] = [];
  activeRootId: string | null;
  activeCollectionId: string | null = null;
  syncState: SyncState;
  personalTemplates: TaskTemplate[];
  spaceTemplates: SpaceTemplate[];
  registrationMode: PublicConfig["registration_mode"] = "closed";
  developmentToolsEnabled = false;
  mobileActions: string[];

  constructor(initial: SessionStateInitial) {
    this.activeRootId = initial.activeRootId;
    this.activeCollectionId = initial.activeCollection?.rootId === initial.activeRootId ? initial.activeCollection.id : null;
    this.syncState = initial.syncState;
    this.personalTemplates = initial.personalTemplates;
    this.spaceTemplates = initial.spaceTemplates;
    this.mobileActions = initial.mobileActions;
  }

  selectRoot(rootId: string | null, clearCollection = true): void {
    this.activeRootId = rootId;
    if (clearCollection) this.activeCollectionId = null;
  }

  markLocal(): void {
    this.syncState = "local";
  }

  applyBootstrap(user: User, roots: Root[], activeRootId: string | null): void {
    this.user = user;
    this.roots = roots;
    if (this.activeRootId !== activeRootId) this.activeCollectionId = null;
    this.activeRootId = activeRootId;
  }

  resetUser(): void {
    this.user = null;
  }
}
